import React from "react";

import { FormControl, FormHelperText, TextField } from "@mui/material";

import MouseOverPopover from "components/MouseOverPopover";

import { HELP_LINKS_BY_DESTINATION } from "../../DestinationCreation.constants";
import HelpPopoverCard from "../HelpPopoverCard";

const AccessTokenField = ({
    destinationCode,
    value,
    error,
    language,
    onChange,
}) => {
    const label = language?.destination_modal?.access_token ?? "Access Token";
    const helpLink = HELP_LINKS_BY_DESTINATION[destinationCode]?.token;
    const hasHelp = destinationCode in HELP_LINKS_BY_DESTINATION;

    return (
        <FormControl
            className="mb-3 mouse-over-popover-area"
            style={{ width: "100%" }}
            error={Boolean(error)}
        >
            <TextField
                name="access_token"
                inputProps={{ "data-cy": "create-destination-access-token" }}
                label={label}
                variant="outlined"
                onChange={onChange}
                value={value}
                placeholder={label}
                error={Boolean(error)}
            />
            {error && (
                <FormHelperText>
                    {language?.source_modal?.validation_error ??
                        "Validation Error"}
                </FormHelperText>
            )}
            {hasHelp && (
                <MouseOverPopover
                    text={
                        <HelpPopoverCard
                            title={
                                language?.popover?.to_create_access_token ??
                                "To Create Access Token"
                            }
                            description={
                                language?.popover?.how_to_create_access_token ??
                                "How to create access token? Please refer to the link:"
                            }
                            link={helpLink}
                            language={language}
                        />
                    }
                />
            )}
        </FormControl>
    );
};

export default AccessTokenField;
